/* Koi & Vijverbouw — theme scripts
   Vanilla JS, geen dependencies. Alle interactie uit het design:
   mega menu, zoekpaneel, verlanglijst, ajax winkelwagen + toast,
   productgalerij, varianten, hoeveelheid en de watertest-calculator. */

(function () {
  'use strict';

  var money = window.KVMoneyFormat || '€ {{amount_with_comma_separator}}';
  var S = window.KVStrings || {};

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return money.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------------------------------------------------------------- Toast */

  var toastTimer;
  function showToast(message) {
    var el = document.getElementById('kv-toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2600);
  }
  window.KVToast = showToast;

  /* ------------------------------------------------------------ Taalkiezer */

  function initLangPicker() {
    document.querySelectorAll('[data-langpick]').forEach(function (pick) {
      var toggle = pick.querySelector('[data-langpick-toggle]');
      var menu = pick.querySelector('[data-langpick-menu]');
      if (!toggle || !menu) return;

      function open(state) {
        menu.hidden = !state;
        pick.toggleAttribute('data-open', state);
        toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
      }
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        open(menu.hidden);
      });
      document.addEventListener('click', function (e) {
        if (!pick.contains(e.target)) open(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') open(false);
      });
    });
  }

  /* --------------------------------------------------------------- Header */

  function initHeader() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    var overlay = document.querySelector('.header__overlay');

    function setNav(open) {
      if (!nav) return;
      if (!open) {
        nav.querySelectorAll('[data-mega-item][open]').forEach(function (d) {
          d.removeAttribute('open');
        });
      }
      nav.classList.toggle('is-open', open);
      document.body.classList.toggle('nav-open', open);
      if (overlay) overlay.hidden = !open;
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    window.KVCloseNav = function () { setNav(false); };

    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        setNav(!nav.classList.contains('is-open'));
      });

      document.querySelectorAll('[data-nav-close]').forEach(function (el) {
        el.addEventListener('click', function () { setNav(false); });
      });

      // Doorklikken sluit het paneel, anders blijft het over de pagina hangen
      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { setNav(false); });
      });

      // Terug naar desktop: paneelstand opruimen
      var breed = window.matchMedia('(min-width: 990px)');
      breed.addEventListener('change', function (e) {
        if (e.matches) setNav(false);
      });
    }

    /* Mega menu.

       Of hoveren zinvol is hangt af van het invoerapparaat, niet van de
       schermbreedte: een iPad is 1024 px breed maar heeft geen muis. Op zo'n
       apparaat opende de eerste tik het menu en navigeerde de tweede weg —
       dat voelt als een kapot menu. Vandaar (hover: hover). */
    var items = document.querySelectorAll('[data-mega-item]');
    var kanHoveren = window.matchMedia('(hover: hover) and (pointer: fine)');
    var desktop = window.matchMedia('(min-width: 990px)');

    function magHoveren() {
      return kanHoveren.matches && desktop.matches;
    }

    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) item.removeAttribute('open');
      });
    }

    items.forEach(function (item) {
      var summary = item.querySelector('summary');

      item.addEventListener('mouseenter', function () {
        if (!magHoveren()) return;
        closeAll(item);
        item.setAttribute('open', '');
      });

      /* Zonder muis klappen we zelf open. Het native gedrag van <details>
         binnen een fixed panel met een transform is op mobiel niet
         betrouwbaar, dus nemen we het daar over. */
      if (summary) {
        summary.addEventListener('click', function (event) {
          if (magHoveren()) return;
          event.preventDefault();
          var wasOpen = item.hasAttribute('open');
          closeAll(null);
          if (!wasOpen) item.setAttribute('open', '');
        });
      }

      item.addEventListener('toggle', function () {
        if (item.hasAttribute('open') && magHoveren()) closeAll(item);
      });
    });

    var headerWrap = document.querySelector('[data-header-wrap]');
    if (headerWrap) {
      headerWrap.addEventListener('mouseleave', function () {
        if (magHoveren()) closeAll(null);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll(null);
        closeSearch();
        setNav(false);
      }
    });

    // Zoekpaneel
    var searchToggle = document.querySelector('[data-search-toggle]');
    var searchPanel = document.querySelector('[data-search-panel]');

    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.hidden = true;
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    }
    window.KVCloseSearch = closeSearch;

    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        closeAll(null);
        searchPanel.hidden = !searchPanel.hidden;
        searchToggle.setAttribute('aria-expanded', searchPanel.hidden ? 'false' : 'true');
        if (!searchPanel.hidden) {
          var input = searchPanel.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });
      searchPanel.querySelectorAll('[data-search-close]').forEach(function (btn) {
        btn.addEventListener('click', closeSearch);
      });
    }

    initPredictiveSearch(searchPanel);
  }

  /* --------------------------------------------- Live zoeksuggesties (autocomplete) */

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initPredictiveSearch(panel) {
    if (!panel) return;
    var input = panel.querySelector('[data-predictive-input]');
    var results = panel.querySelector('[data-predictive-results]');
    var dflt = panel.querySelector('[data-predictive-default]');
    if (!input || !results) return;

    var timer = null;
    var vorige = '';

    function toonStandaard() {
      results.hidden = true;
      results.innerHTML = '';
      if (dflt) dflt.hidden = false;
      input.setAttribute('aria-expanded', 'false');
    }

    function render(data, q) {
      var res = (data.resources && data.resources.results) || {};
      var producten = res.products || [];
      var queries = res.queries || [];

      var html = '';
      if (queries.length) {
        html += '<ul class="search-results__queries">';
        queries.slice(0, 4).forEach(function (item) {
          html += '<li><a href="' + item.url + '"><span class="search-results__q-ico" aria-hidden="true">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>' +
            '</span><span>' + (item.styled_text || escapeHtml(item.text || '')) + '</span></a></li>';
        });
        html += '</ul>';
      }

      if (producten.length) {
        html += '<ul class="search-results__products">';
        producten.slice(0, 6).forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          var thumb = img
            ? '<span class="search-results__thumb"><img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy"></span>'
            : '<span class="search-results__thumb"></span>';
          var type = p.product_type ? '<span class="search-results__type">' + escapeHtml(p.product_type) + '</span>' : '';
          html += '<li><a href="' + p.url + '" class="search-results__product">' + thumb +
            '<span class="search-results__meta"><span class="search-results__name">' + escapeHtml(p.title) + '</span>' + type +
            '</span></a></li>';
        });
        html += '</ul>';
      }

      if (!producten.length && !queries.length) {
        html = '<div class="search-results__empty">Geen suggesties voor “' + escapeHtml(q) + '”</div>';
      } else {
        html += '<a class="search-results__all" href="/search?q=' + encodeURIComponent(q) + '&options[prefix]=last">' +
          'Alle resultaten voor “' + escapeHtml(q) + '”' +
          '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
      }

      results.innerHTML = html;
      results.hidden = false;
      if (dflt) dflt.hidden = true;
      input.setAttribute('aria-expanded', 'true');
    }

    function zoek(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) {
          // Bij een wachtwoordpoort/redirect komt er geen JSON terug; dan niets tonen.
          if (!r.ok || (r.redirected && r.url.indexOf('/password') > -1)) throw new Error('geen json');
          return r.json();
        })
        .then(function (data) { if (input.value.trim() === q) render(data, q); })
        .catch(function () { /* stil: bij een fout blijft de normale zoekbalk werken */ });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q === vorige) return;
      vorige = q;
      clearTimeout(timer);
      if (q.length < 2) { toonStandaard(); return; }
      timer = setTimeout(function () { zoek(q); }, 200);
    });

    // Klik buiten de resultaten? Terug naar de standaard-suggesties.
    input.addEventListener('search', function () { if (!input.value) toonStandaard(); });
  }

  /* ---------------------------------------------------------- Verlanglijst */

  var WISH_KEY = 'kv-wishlist';

  function readWishlist() {
    var list;
    try { list = JSON.parse(localStorage.getItem(WISH_KEY)) || []; }
    catch (e) { return []; }
    // Alleen geldige handles behouden (lege of oude numerieke waarden weg),
    // zodat de teller en de verlanglijstpagina altijd overeenkomen.
    if (!Array.isArray(list)) return [];
    return list.filter(function (h) {
      return typeof h === 'string' && /[a-z]/i.test(h);
    });
  }

  function writeWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
    var count = document.querySelector('[data-wishlist-count]');
    if (count) {
      count.textContent = list.length;
      count.hidden = list.length === 0;
    }
  }

  function initWishlist() {
    var list = readWishlist();
    writeWishlist(list);

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-toggle');
      if (list.indexOf(id) !== -1) btn.setAttribute('aria-pressed', 'true');

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var current = readWishlist();
        var index = current.indexOf(id);
        if (index === -1) {
          current.push(id);
          btn.setAttribute('aria-pressed', 'true');
          showToast(btn.getAttribute('data-wishlist-added') || 'Op je verlanglijst ✓');
        } else {
          current.splice(index, 1);
          btn.setAttribute('aria-pressed', 'false');
        }
        writeWishlist(current);
      });
    });
  }

  /* ------------------------------------------------------------ Winkelwagen */

  function updateCartCount(count) {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    // De binnenste span behouden (die is 1px genudged voor nette centrering);
    // valt terug op textContent als de span er (nog) niet is.
    var n = el.querySelector('.icon-btn__count-n');
    if (n) { n.textContent = count; } else { el.textContent = count; }
    el.hidden = count === 0;
  }

  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        bumpCartCount();
      })
      .catch(function () {});
  }

  function initAjaxCart() {
    document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('[type="submit"]');
        var original = button ? button.innerHTML : '';
        if (button) { button.disabled = true; button.textContent = S.adding || 'Bezig…'; }

        fetch(form.action || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: new FormData(form)
        })
          .then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) {
              showToast(result.data.description || result.data.message || S.error);
              return;
            }
            var title = result.data.product_title || form.getAttribute('data-product-title') || '';
            refreshCartCount();
            if (document.querySelector('[data-cart-drawer]')) {
              // De lade opent alleen de EERSTE keer in deze sessie. Daarna
              // werken we de inhoud + de teller stil bij (de klant ziet het
              // mandje-getal veranderen) en tonen we een klein bevestiginkje.
              var eersteKeer = true;
              try { eersteKeer = !sessionStorage.getItem('kv-cart-opened'); } catch (e) {}
              refreshDrawer(eersteKeer);
              if (eersteKeer) {
                try { sessionStorage.setItem('kv-cart-opened', '1'); } catch (e) {}
              } else {
                showToast((S.addedToCart || '{{ title }} ✓').replace('{{ title }}', title));
              }
            } else {
              showToast((S.addedToCart || '{{ title }} ✓').replace('{{ title }}', title));
            }
          })
          .catch(function () { showToast(S.error || 'Er ging iets mis. Probeer het nog eens.'); })
          .finally(function () {
            if (button) { button.disabled = false; button.innerHTML = original; }
          });
      });
    });
  }

  /* ----------------------------------------------------- Winkelwagenlade */

  var drawerBusy = false;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = false;
    document.body.classList.add('drawer-open');
    var close = drawer.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('drawer-open');
  }
  window.KVCloseDrawer = closeDrawer;

  /* De lade opnieuw laten renderen door Shopify zelf: dan hoeven we prijzen,
     kortingen en de verzenddrempel niet in JavaScript na te rekenen. */
  function refreshDrawer(keepOpen) {
    return fetch(cartRoot() + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        // Alleen de INHOUD van het paneel vervangen. Het paneel zelf blijft in
        // de DOM, dus de inschuif-animatie speelt niet opnieuw af (geen flikker).
        var versPanel = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('.drawer__panel');
        var huidigPanel = document.querySelector('.drawer__panel');
        if (!versPanel || !huidigPanel) return;
        huidigPanel.innerHTML = versPanel.innerHTML;
        bindPanel(huidigPanel);
        initQuantity(huidigPanel);
        if (keepOpen) openDrawer();
      })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    if (drawerBusy) return;
    drawerBusy = true;
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.classList.add('is-busy');

    fetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshDrawer(true);
      })
      .catch(function () { showToast(S.error); })
      .finally(function () {
        drawerBusy = false;
        var d = document.querySelector('[data-cart-drawer]');
        if (d) d.classList.remove('is-busy');
      });
  }

  /* Bindt alleen de interacties BINNEN het paneel. De overlay zit erbuiten en
     wordt eenmalig gebonden, zodat een refresh geen dubbele listeners geeft. */
  function bindPanel(panel) {
    panel.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    panel.querySelectorAll('[data-cart-quantity]').forEach(function (input) {
      input.addEventListener('change', function () {
        changeLine(parseInt(input.getAttribute('data-cart-quantity'), 10),
                   Math.max(0, parseInt(input.value, 10) || 0));
      });
    });
    panel.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(parseInt(btn.getAttribute('data-cart-remove'), 10), 0);
      });
    });
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    document.querySelectorAll('[data-cart-open]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        refreshDrawer(true);
      });
    });

    // De overlay ligt buiten het paneel en wordt maar één keer gebonden
    var overlay = drawer.querySelector('.drawer__overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    var panel = drawer.querySelector('.drawer__panel');
    if (panel) bindPanel(panel);
  }

  /* ------------------------------------------------------------ Hoeveelheid */

  function initQuantity(root) {
    (root || document).querySelectorAll('[data-quantity]').forEach(function (widget) {
      var input = widget.querySelector('input');
      widget.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
          var min = parseInt(input.min || '1', 10);
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------------- Productpg. */

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
      if (!slides.length) return;

      function speel(video) {
        if (!video) return;
        video.muted = true;               // browsers staan autoplay alleen toe zonder geluid
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }

      function toon(id) {
        slides.forEach(function (slide) {
          var actief = slide.getAttribute('data-media-id') === id;
          slide.classList.toggle('is-active', actief);
          var video = slide.querySelector('video');
          if (video) { if (actief) { speel(video); } else { video.pause(); } }
        });
        thumbs.forEach(function (t) {
          var actief = t.getAttribute('data-media-id') === id;
          t.classList.toggle('is-active', actief);
          t.setAttribute('aria-current', actief ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          toon(thumb.getAttribute('data-media-id'));
        });
      });

      // Is het eerste medium een video? Meteen (gedempt) afspelen.
      var eerste = slides[0];
      if (eerste) speel(eerste.querySelector('video'));
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = picker.closest('form');
      var dataEl = document.getElementById(picker.getAttribute('data-variants'));
      if (!dataEl || !form) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = form.querySelector('[name="id"]');
      var selects = picker.querySelectorAll('select');
      var priceEl = document.querySelector('[data-variant-price]');
      var compareEl = document.querySelector('[data-variant-compare]');
      var skuEl = document.querySelector('[data-variant-sku]');
      var stockEl = document.querySelector('[data-variant-stock]');
      var submit = form.querySelector('[type="submit"]');

      function update() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variants.filter(function (v) {
          return chosen.every(function (value, i) { return v.options[i] === value; });
        })[0];

        if (!match) {
          if (submit) { submit.disabled = true; submit.textContent = S.unavailable || 'Niet beschikbaar'; }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(match.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (skuEl) skuEl.textContent = match.sku ? 'SKU ' + match.sku : '';
        if (stockEl) {
          // Voorraad >=1 -> op voorraad; 0 met nabestellen -> verwachte levertijd;
          // 0 zonder nabestellen -> uitverkocht. Teksten staan op de data-attributen.
          var state = 'instock';
          if (match.tracked && (match.inventory_quantity || 0) < 1) {
            state = match.available ? 'backorder' : 'soldout';
          }
          var txt = stockEl.getAttribute('data-instock') || S.inStock;
          if (state === 'backorder') { txt = stockEl.getAttribute('data-backorder') || txt; }
          else if (state === 'soldout') { txt = stockEl.getAttribute('data-soldout') || S.soldOut; }
          stockEl.textContent = txt;
          stockEl.classList.toggle('stock--backorder', state === 'backorder');
          stockEl.classList.toggle('stock--out', state === 'soldout');
        }
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? S.addToCart : S.soldOut;
        }

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });
    });
  }

  /* -------------------------------------------------------------- Watertest */

  /* De drempelwaarden staan hier; de teksten komen vertaald uit de sectie
     (locales/*.json → data-watertest-messages). */
  var WT_RULES = [
    { key: 'kh', test: function (v) { return v < 6; } },
    { key: 'gh', test: function (v) { return v < 8; } },
    { key: 'ph', test: function (v) { return v < 7 || v > 8.5; } },
    { key: 'no2', test: function (v) { return v > 0.15; } },
    { key: 'nh3', test: function (v) { return v > 0.05; } },
    { key: 'temp', test: function (v) { return v < 12; } }
  ];

  function initWatertest() {
    var form = document.querySelector('[data-watertest]');
    if (!form) return;
    var result = form.querySelector('[data-watertest-result]');
    var listEl = form.querySelector('[data-watertest-advice]');
    var messagesEl = form.querySelector('[data-watertest-messages]');

    var messages = {};
    if (messagesEl) {
      try { messages = JSON.parse(messagesEl.textContent); } catch (e) { messages = {}; }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var advice = [];

      WT_RULES.forEach(function (rule) {
        var input = form.querySelector('[name="' + rule.key + '"]');
        if (!input || !input.value.trim()) return;
        var value = parseFloat(input.value.replace(',', '.'));
        if (isNaN(value)) return;
        if (!rule.test(value)) return;

        var text = messages[rule.key];
        if (!text) return;
        advice.push(text.replace('__VALUE__', input.value.trim()));
      });

      if (!advice.length && messages.ok) {
        advice.push(messages.ok);
      }

      listEl.innerHTML = '';
      advice.forEach(function (text) {
        var li = document.createElement('li');
        li.className = 'watertest__advice';
        li.textContent = text;
        listEl.appendChild(li);
      });

      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  /* --------------------------------------------------------------- Filters */

  function collectionSectionId() {
    var wrap = document.querySelector('[data-collection]');
    return wrap ? wrap.id.replace('Collection-', '') : null;
  }

  /* Filteren zonder de pagina te herladen. We laten Shopify de sectie
     opnieuw renderen en wisselen alleen de zijbalk en de resultaten om —
     zo blijven scrollpositie en de openstaande filtergroepen behouden. */
  function applyFacets(url, push) {
    var wrap = document.querySelector('[data-collection]');
    var sectionId = collectionSectionId();
    if (!wrap || !sectionId) { window.location.href = url; return; }

    wrap.classList.add('is-filtering');

    var scheiding = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + scheiding + 'section_id=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var vers = new DOMParser().parseFromString(html, 'text/html');

        // Welke filtergroepen stonden open?
        var open = [];
        wrap.querySelectorAll('[data-facets-inner] .facets__group').forEach(function (g, i) {
          if (g.open) open.push(i);
        });

        [['[data-facets-inner]', true], ['[data-collection-results]', false]].forEach(function (paar) {
          var oud = wrap.querySelector(paar[0]);
          var nieuw = vers.querySelector(paar[0]);
          if (oud && nieuw) oud.replaceWith(nieuw);
        });

        wrap.querySelectorAll('[data-facets-inner] .facets__group').forEach(function (g, i) {
          g.open = open.indexOf(i) !== -1;
        });

        var teller = vers.querySelector('[data-facets-open]');
        var huidig = wrap.querySelector('[data-facets-open]');
        if (teller && huidig) huidig.innerHTML = teller.innerHTML;

        if (push) history.pushState({ kv: true }, '', url);
        bindFacets();
        initWishlist();
        initAjaxCart();
        initViewSwitch();
        setupLoadMore();
    initPerPage();
    setupLoadMore();
    initCarousels();
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { wrap.classList.remove('is-filtering'); });
  }

  function facetUrl(form) {
    var params = new URLSearchParams(new FormData(form));
    // Lege prijsvelden horen niet in de url
    Array.from(params.keys()).forEach(function (k) {
      if (params.get(k) === '') params.delete(k);
    });
    var basis = window.location.pathname;
    var query = params.toString();
    return query ? basis + '?' + query : basis;
  }

  function bindFacets() {
    var form = document.getElementById('FacetForm');
    var sort = document.getElementById('SortForm');

    if (form) {
      var timer;
      form.addEventListener('change', function (event) {
        if (event.target.type === 'number') return;
        applyFacets(facetUrl(form), true);
      });
      form.addEventListener('input', function (event) {
        if (event.target.type !== 'number') return;
        clearTimeout(timer);
        timer = setTimeout(function () { applyFacets(facetUrl(form), true); }, 700);
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        applyFacets(facetUrl(form), true);
      });
    }

    if (sort) {
      sort.addEventListener('change', function () { applyFacets(facetUrl(sort), true); });
    }

    // Actieve filters wegklikken en paginering blijven ook binnen de pagina
    document.querySelectorAll('[data-collection] .facets__chip, [data-collection] .facets__clear, [data-collection] .pagination a')
      .forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          applyFacets(link.getAttribute('href'), true);
          if (link.closest('.pagination')) {
            window.scrollTo({ top: document.querySelector('[data-collection]').offsetTop - 100, behavior: 'smooth' });
          }
        });
      });

    document.querySelectorAll('[data-facet-more]').forEach(function (button) {
      button.addEventListener('click', function () {
        button.closest('.facets__values').classList.add('is-expanded');
        button.remove();
      });
    });
  }

  function initFacets() {
    if (!document.querySelector('[data-collection]')) return;

    bindFacets();

    // Filterlade op mobiel
    var facets = document.querySelector('[data-facets]');
    var overlay = document.querySelector('.facets__overlay');

    function setFacets(open) {
      if (!facets) return;
      facets.classList.toggle('is-open', open);
      document.body.classList.toggle('facets-open', open);
      if (overlay) overlay.hidden = !open;
    }

    document.querySelectorAll('[data-facets-open]').forEach(function (b) {
      b.addEventListener('click', function () { setFacets(true); });
    });
    document.querySelectorAll('[data-facets-close]').forEach(function (b) {
      b.addEventListener('click', function () { setFacets(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setFacets(false);
    });

    // Terugknop van de browser blijft werken
    window.addEventListener('popstate', function () {
      applyFacets(window.location.pathname + window.location.search, false);
    });
  }

  /* ------------------------------------------------------- Productcarrousel */

  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var head = carousel.closest('.shopify-section') || carousel.parentElement || document;
      var prev = head.querySelector('[data-carousel-prev]');
      var next = head.querySelector('[data-carousel-next]');
      if (!track) return;

      function stap() {
        var item = track.querySelector('.carousel__item');
        var breedte = item ? item.getBoundingClientRect().width + 24 : track.clientWidth;
        // Zoveel hele items als er zichtbaar zijn
        return Math.max(1, Math.floor(track.clientWidth / breedte)) * breedte;
      }

      function bijwerken() {
        if (!prev || !next) return;
        // Valt er niets te scrollen (bijv. maar een paar producten)? Verberg de
        // knoppen i.p.v. ze grijs/'dood' te tonen. Anders blijven ze altijd
        // actief, zodat je aan begin en eind kunt doorklikken (wrap-around).
        var hasOverflow = track.scrollWidth - track.clientWidth > 4;
        var nav = prev.parentElement;
        if (nav) nav.style.display = hasOverflow ? '' : 'none';
        prev.disabled = false;
        next.disabled = false;
      }

      if (next) next.addEventListener('click', function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        // Voorbij het eind? Terug naar het begin (eindeloos doorklikken).
        if (track.scrollLeft >= max) track.scrollTo({ left: 0 });
        else track.scrollBy({ left: stap() });
      });
      if (prev) prev.addEventListener('click', function () {
        if (track.scrollLeft <= 2) track.scrollTo({ left: track.scrollWidth });
        else track.scrollBy({ left: -stap() });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(bijwerken);
      }, { passive: true });
      window.addEventListener('resize', bijwerken);
      bijwerken();
    });
  }

  /* --------------------------------------------------- Per pagina / Toon meer */

  var PERPAGE_KEY = 'kv-perpage';

  function loadMoreProducts(url) {
    var wrap = document.querySelector('[data-collection]');
    var grid = wrap && wrap.querySelector('[data-product-grid]');
    var btn = wrap && wrap.querySelector('[data-load-more]');
    var sectionId = collectionSectionId();
    if (!grid || !sectionId) return Promise.resolve(false);

    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var versGrid = doc.querySelector('[data-product-grid]');
        if (versGrid) {
          Array.prototype.slice.call(versGrid.children).forEach(function (kaart) {
            grid.appendChild(kaart);
          });
        }
        var versBtn = doc.querySelector('[data-load-more]');
        var meer = versBtn && versBtn.getAttribute('data-next-url');
        if (btn) {
          if (meer) { btn.setAttribute('data-next-url', meer); btn.hidden = false; }
          else { btn.removeAttribute('data-next-url'); btn.hidden = true; }
        }
        initWishlist();
        initAjaxCart();
        return !!meer;
      })
      .catch(function () { return false; });
  }

  /* Bindt de 'Toon meer'-knop en laadt bij het openen genoeg pagina's bij om de
     gekozen 'per pagina' te halen. Vervangt de genummerde paginering als JS aan is. */
  function setupLoadMore() {
    var wrap = document.querySelector('[data-collection]');
    if (!wrap) return;

    // Genummerde paginering verbergen: JS neemt het over
    wrap.querySelectorAll('[data-numbered-pagination], .pagination--top').forEach(function (el) {
      el.style.display = 'none';
    });

    var btn = wrap.querySelector('[data-load-more]');
    if (btn && !btn.dataset.bound) {
      btn.dataset.bound = '1';
      var origineel = btn.textContent;
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-next-url');
        if (!url) return;
        btn.disabled = true; btn.textContent = S.adding || '…';
        loadMoreProducts(url).finally(function () {
          btn.disabled = false; btn.textContent = origineel;
        });
      });
    }
    if (btn && btn.getAttribute('data-next-url')) btn.hidden = false;

    // Bijladen tot de gekozen 'per pagina' is bereikt
    var doel = 24;
    try { doel = parseInt(localStorage.getItem(PERPAGE_KEY), 10) || 24; } catch (e) {}
    (function stap() {
      var grid = wrap.querySelector('[data-product-grid]');
      var b = wrap.querySelector('[data-load-more]');
      if (!grid || grid.children.length >= doel) return;
      if (!b || !b.getAttribute('data-next-url')) return;
      loadMoreProducts(b.getAttribute('data-next-url')).then(function (meer) {
        if (meer) stap();
      });
    })();
  }

  function initPerPage() {
    var select = document.querySelector('[data-perpage]');
    if (!select) return;
    var per = 24;
    try { per = parseInt(localStorage.getItem(PERPAGE_KEY), 10) || 24; } catch (e) {}
    select.value = String(per);
    select.addEventListener('change', function () {
      try { localStorage.setItem(PERPAGE_KEY, select.value); } catch (e) {}
      // Schoon opnieuw laden vanaf pagina 1 (trimt of breidt uit naar de keuze)
      var url = window.location.pathname + window.location.search.replace(/([?&])page=\d+/, '$1').replace(/[?&]$/, '');
      window.location.href = url;
    });
  }

  /* --------------------------------------------------- Weergaveschakelaar */

  var VIEW_KEY = 'kv-grid-columns';

  function initViewSwitch() {
    var group = document.querySelector('[data-view-switch]');
    var grid = document.querySelector('[data-product-grid]');
    if (!group || !grid) return;

    function apply(count, remember) {
      grid.className = grid.className.replace(/grid--\d/, 'grid--' + count);
      group.querySelectorAll('[data-view]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-view') === String(count) ? 'true' : 'false');
      });
      if (remember) {
        try { localStorage.setItem(VIEW_KEY, count); } catch (e) {}
      }
    }

    var saved = null;
    try { saved = localStorage.getItem(VIEW_KEY); } catch (e) {}
    if (saved && group.querySelector('[data-view="' + saved + '"]')) apply(saved, false);

    group.querySelectorAll('[data-view]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        apply(btn.getAttribute('data-view'), true);
      });
    });
  }

  /* ------------------------------------------------------------- Animaties */

  function motionAllowed() {
    return document.body.classList.contains('animations-on') &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Elementen die vanzelf in beeld mogen komen. Per selector geven we aan
     hoe ze binnenkomen, zodat we niet in elke sectie attributen hoeven te
     zetten. Kinderen van een grid krijgen een oplopende vertraging. */
  var REVEAL = [
    { selector: '.section-head', style: 'up' },
    { selector: '.grid > *', style: 'up', stagger: 70 },
    { selector: '.cat-tile', style: 'zoom', stagger: 70 },
    { selector: '.brand-bar', style: 'fade' },
    { selector: '.why__inner > div:first-child', style: 'left' },
    { selector: '.why__media', style: 'right' },
    { selector: '.cta-band', style: 'up' },
    { selector: '.newsletter', style: 'up' },
    { selector: '.blog-hero__title, .blog-hero__text, .blog-hero__topics', style: 'up', stagger: 90 },
    { selector: '.watertest__intro > *', style: 'left', stagger: 80 },
    { selector: '.watertest__form', style: 'right' },
    { selector: '.product__gallery > *', style: 'up', stagger: 80 },
    { selector: '.buy-box > *', style: 'right', stagger: 90 },
    { selector: '.article__hero, .article__title, .article__body', style: 'up', stagger: 80 }
  ];

  function initReveal() {
    if (!motionAllowed() || !('IntersectionObserver' in window)) return;

    REVEAL.forEach(function (rule) {
      document.querySelectorAll(rule.selector).forEach(function (el) {
        if (el.hasAttribute('data-reveal') || el.closest('.hero')) return;
        el.setAttribute('data-reveal', rule.style);

        if (rule.stagger) {
          var parent = el.parentElement;
          if (parent.__revealSeen === undefined) parent.__revealSeen = 0;
          var position = parent.__revealSeen++;
          // Na acht items geen extra vertraging meer, anders wachten
          // bezoekers bij een grote collectiegrid op de laatste kaart
          el.style.setProperty('--reveal-delay', Math.min(position, 7) * rule.stagger + 'ms');
        }
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      // Wat al in beeld staat bij het laden hoeft niet te wachten op scrollen
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) {
        requestAnimationFrame(function () { el.classList.add('is-visible'); });
      } else {
        observer.observe(el);
      }
    });
  }

  function initStickyHeader() {
    var wrap = document.querySelector('[data-header-wrap]');
    var header = document.querySelector('.header');
    if (!header || !wrap) return;

    // 'always' = alleen krimpen; 'reveal' = wegschuiven bij omlaag, terug bij omhoog
    var mode = wrap.getAttribute('data-sticky') || 'reveal';
    var laatste = window.scrollY;
    var ticking = false;

    function menuOpen() {
      return document.querySelector('[data-mega-item][open]') ||
             document.body.classList.contains('nav-open') ||
             (document.querySelector('[data-search-panel]') && !document.querySelector('[data-search-panel]').hidden);
    }

    function update() {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 40);

      if (mode === 'reveal') {
        // Voorbij de headerhoogte, naar beneden en geen menu open: verbergen
        var omlaag = y > laatste;
        if (y > 200 && omlaag && !menuOpen()) {
          wrap.classList.add('is-hidden');
        } else {
          wrap.classList.remove('is-hidden');
        }
      }
      laatste = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  /* De marquee moet naadloos rondlopen, dus verdubbelen we de inhoud en
     schuiven we precies de helft op. Past alles gewoon? Dan geen marquee. */
  function initMarquee() {
    document.querySelectorAll('[data-marquee]').forEach(function (bar) {
      var track = bar.querySelector('[data-marquee-track]');
      var viewport = bar.querySelector('.brand-bar__viewport');
      if (!track || !viewport || track.dataset.cloned) return;

      if (!motionAllowed()) {
        // Wie geen beweging wil, krijgt een veegbare rij
        bar.classList.remove('brand-bar--marquee');
        return;
      }

      function bouw() {
        var setBreedte = track.scrollWidth;
        if (setBreedte < 10) return;

        // Zo vaak klonen dat de rij minstens twee keer het venster vult.
        // Anders komt bij het opschuiven het einde in beeld met een gat.
        var origineel = Array.prototype.slice.call(track.children);
        var doel = Math.max(viewport.clientWidth * 2, setBreedte * 2);
        var rondes = 0;
        while (track.scrollWidth < doel && rondes < 12) {
          origineel.forEach(function (item) {
            var kloon = item.cloneNode(true);
            kloon.setAttribute('aria-hidden', 'true');
            kloon.tabIndex = -1;
            track.appendChild(kloon);
          });
          rondes++;
        }
        track.dataset.cloned = 'true';

        // Precies één originele set opschuiven: naadloos, want er staan er meer.
        track.style.setProperty('--marquee-distance', setBreedte + 'px');
        track.style.animationDuration = Math.max(18, Math.round(setBreedte / 55)) + 's';
      }

      // Wachten tot de logo-afbeeldingen geladen zijn, anders klopt de breedte niet
      var imgs = track.querySelectorAll('img');
      if (!imgs.length) { bouw(); return; }
      var klaar = 0, totaal = imgs.length;
      function tik() { if (++klaar >= totaal) bouw(); }
      imgs.forEach(function (img) {
        if (img.complete) tik();
        else { img.addEventListener('load', tik); img.addEventListener('error', tik); }
      });
    });
  }

  function bumpCartCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el || !motionAllowed()) return;
    el.classList.remove('is-bumped');
    void el.offsetWidth;
    el.classList.add('is-bumped');
  }

  /* ------------------------------------------------------------------ Init */

  /* ----------------------------------------------------- Verlanglijstpagina */

  function initWishlistPage() {
    var wrap = document.querySelector('[data-wishlist-page]');
    if (!wrap) return;

    var grid = wrap.querySelector('[data-wishlist-grid]');
    var leeg = wrap.querySelector('[data-wishlist-empty]');
    var laden = wrap.querySelector('[data-wishlist-loading]');
    var samenvatting = document.querySelector('[data-wishlist-summary]');

    // Alleen geldige handles gebruiken (oudere versies bewaarden nog IDs)
    var handles = readWishlist().filter(function (h) {
      return typeof h === 'string' && /[a-z]/i.test(h);
    });

    if (!handles.length) return;

    leeg.hidden = true;
    laden.hidden = false;
    var root = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

    Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (kaarten) {
      laden.hidden = true;
      var geldig = kaarten.filter(function (x) { return x && x.trim(); });
      if (!geldig.length) { leeg.hidden = false; return; }

      grid.innerHTML = geldig.join('');
      grid.hidden = false;
      if (samenvatting) {
        samenvatting.textContent = geldig.length + ' ' + (geldig.length === 1 ? 'product' : 'producten');
        samenvatting.hidden = false;
      }
      initWishlist();
      initAjaxCart();

      // Onttharten op deze pagina haalt de kaart meteen weg
      grid.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.getAttribute('aria-pressed') === 'false') {
            var kaart = btn.closest('.card');
            if (kaart) kaart.style.display = 'none';
          }
        });
      });
    });
  }

  /* USP-balk: op mobiel de items automatisch laten doorlopen (één tegelijk). */
  function initUspSlider() {
    var slider = document.querySelector('[data-usp-slider]');
    if (!slider) return;
    var items = slider.querySelectorAll('.usp-bar__item');
    if (items.length < 2) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var timer = null, idx = 0;
    function toon(i) {
      for (var n = 0; n < items.length; n++) items[n].classList.toggle('is-active', n === i);
    }
    function start() {
      if (timer) return;
      idx = 0; toon(0);
      timer = window.setInterval(function () {
        idx = (idx + 1) % items.length;
        toon(idx);
      }, 3200);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function apply() { if (mq.matches) start(); else stop(); }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  /* Welkomst-popup: verschijnt na een korte vertraging, één keer per sessie. */
  function initWelcomePopup() {
    var popup = document.querySelector('[data-welcome-popup]');
    if (!popup) return;
    var KEY = 'kv-welcome-popup';

    function markeer() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
    function open() { popup.hidden = false; document.body.classList.add('popup-open'); }
    function close() {
      popup.hidden = true;
      document.body.classList.remove('popup-open');
      markeer();
    }

    popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    popup.addEventListener('click', function (e) { if (e.target === popup) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) close();
    });

    // Net ingeschreven? Toon de bedanktekst meteen en daarna niet meer.
    if (popup.querySelector('.welcome-popup__done')) { open(); markeer(); return; }

    var dismissed = false;
    try { dismissed = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (dismissed) return;

    var delay = parseInt(popup.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 1500;
    window.setTimeout(open, delay);
  }

  /* Eerder bekeken producten: huidig product onthouden (localStorage) en de
     vorige producten tonen in de grid onderaan de productpagina. */
  function initRecentlyViewed() {
    var KEY = 'kv-recently-viewed';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];

    var curEl = document.querySelector('[data-recently-current]');
    var current = null;
    if (curEl) { try { current = JSON.parse(curEl.textContent); } catch (e) { current = null; } }

    if (current && current.handle) {
      list = list.filter(function (p) { return p && p.handle !== current.handle; });
      list.unshift(current);
      if (list.length > 8) list = list.slice(0, 8);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    var wrap = document.querySelector('[data-recently-viewed]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    var currentHandle = current && current.handle;
    var toShow = list.filter(function (p) { return p && p.handle && p.handle !== currentHandle; }).slice(0, 4);
    if (!toShow.length) return;

    grid.innerHTML = toShow.map(function (p) {
      var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '';
      return '<a class="card product-card" href="' + p.url + '">' +
        '<div class="product-card__media">' + img + '</div>' +
        '<div class="product-card__body">' +
          '<div class="product-card__title">' + escapeHtml(p.title || '') + '</div>' +
          '<div class="product-card__price">' + escapeHtml(p.price || '') + '</div>' +
        '</div>' +
      '</a>';
    }).join('');
    wrap.hidden = false;
  }

  /* Sticky koop-balk: verschijnt zodra de hoofd-koopknop uit beeld is en
     koppelt de knop aan het hoofd-productformulier. */
  function initStickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var form = document.querySelector('form[data-ajax-cart]');
    var mainBtn = form ? form.querySelector('[type="submit"]') : null;
    var anchor = mainBtn || document.querySelector('.buy-box');
    if (!anchor) return;

    var stickyAdd = bar.querySelector('[data-sticky-add]');
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') { form.requestSubmit(mainBtn || undefined); }
        else { form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
      });
    }

    var obs = new IntersectionObserver(function (entries) {
      var e = entries[0];
      // Tonen zodra de hoofdknop naar boven uit beeld is gescrold.
      bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
    }, { threshold: 0 });
    obs.observe(anchor);
  }

  /* Google-reviews: haalt de echte reviews live op via de Places API en vervangt
     de handmatige terugval. Doet niets zonder Place ID + API-sleutel. */
  function initGoogleReviews() {
    var el = document.querySelector('[data-google-reviews]');
    if (!el) return;
    var placeId = el.getAttribute('data-place-id');
    var apiKey = el.getAttribute('data-api-key');
    if (!placeId || !apiKey) return;

    function render() {
      try {
        var svc = new google.maps.places.PlacesService(document.createElement('div'));
        svc.getDetails(
          { placeId: placeId, fields: ['rating', 'user_ratings_total', 'reviews', 'url'] },
          function (place, status) {
            if (status !== google.maps.places.PlacesServiceStatus.OK || !place) return;
            var reviews = (place.reviews || []).filter(function (r) { return r.text; }).slice(0, 6);
            if (reviews.length) {
              el.innerHTML = reviews.map(function (r) {
                var full = Math.round(r.rating || 5), stars = '';
                for (var i = 0; i < 5; i++) { stars += i < full ? '★' : '☆'; }
                var avatar = r.profile_photo_url
                  ? '<img class="review__avatar" src="' + r.profile_photo_url + '" alt="" loading="lazy" referrerpolicy="no-referrer">'
                  : '';
                return '<div class="review review--google">' +
                  '<span class="review__stars" aria-label="' + (r.rating || 5) + ' van 5">' + stars + '</span>' +
                  '<div class="review__text">“' + escapeHtml(r.text) + '”</div>' +
                  '<div class="review__who">' + avatar +
                    '<span>' + escapeHtml(r.author_name || '') +
                    (r.relative_time_description ? ' <span class="review__when">· ' + escapeHtml(r.relative_time_description) + '</span>' : '') +
                    '</span>' +
                  '</div>' +
                '</div>';
              }).join('');
            }
            var note = document.querySelector('[data-google-note]');
            if (note && place.rating) {
              var rating = place.rating.toFixed(1).replace('.', ',');
              var total = place.user_ratings_total || reviews.length;
              var link = place.url ? ' · <a href="' + place.url + '" target="_blank" rel="noopener">Bekijk op Google</a>' : '';
              note.innerHTML = '★ ' + rating + ' uit ' + total + ' Google-reviews' + link;
            }
          }
        );
      } catch (e) { /* stil: handmatige reviews blijven staan */ }
    }

    if (window.google && window.google.maps && window.google.maps.places) { render(); return; }
    window.kvGoogleReviewsCb = render;
    if (!document.querySelector('script[data-google-maps]')) {
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) +
              '&libraries=places&callback=kvGoogleReviewsCb&loading=async';
      s.async = true; s.defer = true; s.setAttribute('data-google-maps', '');
      document.head.appendChild(s);
    }
  }

  function init() {
    // Elke stap in een eigen try/catch met een DIRECTE aanroep. Zo wordt ook een
    // ontbrekende functie opgevangen (een array met de namen zou al crashen bij
    // het opbouwen). Eén fout legt nooit meer de rest plat.
    function logErr(e) { if (window.console && console.error) console.error('[theme init]', e); }
    try { initHeader(); } catch (e) { logErr(e); }
    try { initLangPicker(); } catch (e) { logErr(e); }
    try { initWishlist(); } catch (e) { logErr(e); }
    try { initAjaxCart(); } catch (e) { logErr(e); }
    try { initCartDrawer(); } catch (e) { logErr(e); }
    try { initQuantity(); } catch (e) { logErr(e); }
    try { initGallery(); } catch (e) { logErr(e); }
    try { initVariants(); } catch (e) { logErr(e); }
    try { initWatertest(); } catch (e) { logErr(e); }
    try { initFacets(); } catch (e) { logErr(e); }
    try { initViewSwitch(); } catch (e) { logErr(e); }
    try { initPerPage(); } catch (e) { logErr(e); }
    try { setupLoadMore(); } catch (e) { logErr(e); }
    try { initCarousels(); } catch (e) { logErr(e); }
    try { initWishlistPage(); } catch (e) { logErr(e); }
    try { initRecentlyViewed(); } catch (e) { logErr(e); }
    try { initStickyBuy(); } catch (e) { logErr(e); }
    try { initReveal(); } catch (e) { logErr(e); }
    try { initStickyHeader(); } catch (e) { logErr(e); }
    try { initMarquee(); } catch (e) { logErr(e); }
    try { initUspSlider(); } catch (e) { logErr(e); }
    try { initWelcomePopup(); } catch (e) { logErr(e); }
    try { initGoogleReviews(); } catch (e) { logErr(e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor: opnieuw initialiseren na een sectie-render
  document.addEventListener('shopify:section:load', init);
})();
